import React from 'react';
import {ArrowRight, Mail, Eye, LineChart, Folder} from 'lucide-react';
import {Link} from "react-router-dom";
import {LiaUserEditSolid} from "react-icons/lia";
import Swal from "sweetalert2";
import useApi from "../../../utils/useApi";

const ClientAccountActions = ({ user, isArchived, className, includeProgressBtn = false, onArchiveSuccess, year }) => {
    const api = useApi();
    const handleArchiveToggle = async (clientId, isArchived, clientName) => {
        try {
            const result = await Swal.fire({
                                               title: 'Are you sure?',
                                               text: `Do you want to ${isArchived ? 'unarchive' : 'archive'} client ${clientName}?`,
                                               icon: 'question',
                                               showCancelButton: true,
                                               confirmButtonColor: '#3085d6',
                                               cancelButtonColor: '#d33',
                                               confirmButtonText: isArchived ? 'Yes, unarchive!' : 'Yes, archive!',
                                               cancelButtonText: 'Cancel'
                                           });

            if (result.isConfirmed) {
                let response;
                if (isArchived) {
                    response = await api.unarchiveClient(clientId);
                } else {
                    response = await api.archiveClient(clientId);
                }

                onArchiveSuccess();

                // Show success message
                await Swal.fire({
                                    title: 'Success!',
                                    text: response.message,
                                    icon: 'success',
                                    timer: 2000,
                                    showConfirmButton: false
                                });


            }
        }
        catch (error) {
            // Show error message
            await Swal.fire({
                                title: 'Error!',
                                text: error.message,
                                icon: 'error'
                            });

        }
    };

    return (
        <div className={`grid grid-cols-1
        sm:grid-cols-1
        md:grid-cols-1
        lg:grid-cols-3
        min-[1315px]:grid-cols-3
        min-[1100px]:grid-cols-1
        max-
        gap-4 w-full ${className ? className : ''}`}>
            {/* Profile Section */}
            <div>
                <Link
                    to={`/client/${user.id}/edit?year=${year}`}
                    className="w-full block px-4 py-2 text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors flex items-center gap-2"
                >
                    <LiaUserEditSolid size={24} /> Update {user.profile.client}
                </Link>
            </div>

            {/* Main Actions */}
            <div className="flex flex-row flex-wrap gap-2 flex-grow">
                <Link
                    to={`/client/questionnaire/${user.id}?year=${year}`}
                    className="flex-grow flex justify-center px-4 py-2 text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors text-center"
                >
                    Tax Questionnaire <i className="fas fa-newspaper ml-2"/>
                </Link>

                {includeProgressBtn && (
                    <Link
                        to={`/client-progress/${user.id}?year=${year}`}
                        className="flex-grow inline-flex items-center justify-center gap-2 px-4 py-2 text-white rounded-lg transition-colors text-center bg-indigo-500 dark:bg-indigo-600
                    text-white
                    hover:bg-indigo-600 dark:hover:bg-indigo-700"
                    >
                        Progress <LineChart className="w-4 h-4"/>
                    </Link>
                )}


                <Link
                    to={`/documents/${user.id}?year=${year}`}
                    className="flex-grow inline-flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-center"
                >
                    Documents <Eye className="w-4 h-4"/>
                </Link>

                <button
                    onClick={() => handleArchiveToggle(
                        user.id,
                        user.is_archived,
                        user.profile.client
                    )}
                    className="flex-grow inline-flex items-center justify-center gap-2 px-4 py-2 text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                >
                    <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        {user.is_archived ? (
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z"/>
                        ) : (
                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"/>
                         )}
                    </svg>
                    {user.is_archived ? 'Unarchive' : 'Archive'}
                </button>
            </div>

            {/* Communication Actions */}
            <div className="flex flex-col
            max-[640px]:flex-row
            min-[1100px]:flex-row
            min-[1315px]:flex-col
            xs:flex-row
            sm:flex-row lg:flex-col gap-2">
                <Link
                    to={`/view-letters/${user.id}?year=${year}`}
                    className="flex-grow inline-flex items-center justify-center gap-2 px-4 py-2 bg-cyan-600 text-white rounded-lg hover:bg-cyan-700 transition-colors text-center"
                >
                    View Sent Letters <Mail className="w-4 h-4"/>
                </Link>

                <Link
                    to={`/send-letter/${user.id}`}
                    className="flex-grow inline-flex items-center justify-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-center"
                >
                    Send Letter <ArrowRight className="w-4 h-4"/>
                </Link>
            </div>
        </div>
    );
}



export default ClientAccountActions;
